module.exports = __webpack_public_path__ + "static/media/SourceSansPro-Semibold.47cdf0bc.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SourceSansPro-Semibold.ttf
// module id = 342
// module chunks = 3